import axios from 'axios';
import {
  getAllRewardsURL,
  GetAnnouncedGiftsProductsListUrl,
  getgiftDetailUrl,
  GetMyRetailersGiftTransactionsUrl,
  getNetworkInfluencesURL,
  giftHistoryUrl,
  sendOTPforGiftUrl,
  UploadGiftImageUrl,
  verifyOTPforGiftUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';

export const GetAnnouncedGiftsProductsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${GetAnnouncedGiftsProductsListUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetMyRetailersGiftTransactionsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${GetMyRetailersGiftTransactionsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllRewardsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const { start_date, end_date, type, manufacturer_id, user_esi_id } = data;
    const queryParams = new URLSearchParams();
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (type) queryParams.append('type', type);
    if (manufacturer_id) queryParams.append('manufacturer_id', manufacturer_id);
    if (user_esi_id) queryParams.append('user_esi_id', user_esi_id);

    const url = `${getAllRewardsURL()}?${queryParams.toString()}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getNetworkInfluencerRewardsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const { start_date, end_date, network_id, manufacturer_id, network_esi_id, user_esi_id } = data;
    const queryParams = new URLSearchParams();
    if (network_id) queryParams.append('network_id', network_id);
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (manufacturer_id) queryParams.append('manufacturer_id', manufacturer_id);
    if (user_esi_id) queryParams.append('user_esi_id', user_esi_id);
    if (network_esi_id) queryParams.append('network_esi_id', network_esi_id);

    const url = `${getNetworkInfluencesURL()}?${queryParams.toString()}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getgiftDetailAction = async (gift_id, type, user_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const url = `${getgiftDetailUrl()}?id=${gift_id}&type=${type}&user_esi_id=${user_esi_id}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const sendOTPforGiftAction = async (gift_id, type, user_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const url = `${sendOTPforGiftUrl()}?gift_id=${gift_id}&type=${type}&user_esi_id=${user_esi_id}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const verifyOTPforGiftAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .patch(verifyOTPforGiftUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getGiftHistoryAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(giftHistoryUrl(), {
          params: params,
          ...getTokenHeader(token),
        })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const UploadGiftImage = async (payload) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${UploadGiftImageUrl()}`,
        payload,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

